"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemTooltip = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.ListItemTooltip = function (_a) {
    var children = _a.children, className = _a.className, bubbleAlignPoints = _a.bubbleAlignPoints, restProps = tslib_1.__rest(_a, ["children", "className", "bubbleAlignPoints"]);
    return (react_1.default.createElement("span", tslib_1.__assign({ className: classnames_1.default("gd-list-item-tooltip", className) }, restProps),
        react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, null,
            react_1.default.createElement("span", { className: "gd-icon-circle-question gd-list-item-tooltip-icon" }),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: bubbleAlignPoints }, children))));
};
//# sourceMappingURL=ListItemTooltip.js.map